export default __webpack_public_path__ + "static/media/olivex_logo.1321cb40.webp";